import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from "../../../errors/api-error-handler";
import { ArticlesFilteredsInitialStateType, ArticlesFilteredsTypes } from "../../../models/news-articles/articles-filtered-model";
import ArticlesFilteredsServices from "../../../services/news-articles/articles-filtered.service";

const initialState: ArticlesFilteredsInitialStateType = {
    ArticlesFilteredsData: [],
    ArticlesFilteredsPinnedData: [],
    ArticlesFilteredsData393: [],
    ArticlesFilteredsData397: [],
    ArticlesFilteredsData398: [],
    ArticlesFilteredsData400: [],
    ArticlesFilteredsData404: [],
    ArticlesFilteredsLoading: true,
    ArticlesFilteredsError: undefined,
};

type QueryParamsType = {
  categoryId: string,
  isInclude: boolean, 
  noOfArticles: number
} 

export const retrieveArticlesFiltereds = createAsyncThunk(
  "ArticlesFiltereds/retrieve",
  async (queryParams: QueryParamsType,  { rejectWithValue }) => {
    try {
        const response = await ArticlesFilteredsServices.getAllArticlesFiltereds(queryParams.categoryId, queryParams.isInclude, queryParams.noOfArticles);
        return [response.data];
    }catch (error: any) {
        if (!error.response) {
            throw error
          }
        return rejectWithValue(error.response.status) 
    }   
})
  

const ArticlesFilteredsSlice = createSlice({
  name: "NewsArticlesSearc",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(retrieveArticlesFiltereds.pending, (state) => {
        state.ArticlesFilteredsLoading = true;
      })
      .addCase(retrieveArticlesFiltereds.fulfilled, (state, action) => {
        if (action.payload) {
          state.ArticlesFilteredsLoading = false;
          state.ArticlesFilteredsData = action.payload as ArticlesFilteredsTypes[];
        }
      })
      .addCase(retrieveArticlesFiltereds.rejected, (state, { payload }) => {
        state.ArticlesFilteredsLoading = false;
        state.ArticlesFilteredsError = apiErrorHandler(Number(payload));
      });
  },
});

export const selectAllEntities = (state: { entities: any }) => state.entities;
export default ArticlesFilteredsSlice.reducer;
